export enum FrequencyViewType {
  ConversionRate = `ConversionRate`,
  Conversion = `Conversion`,
  Dropoff = `Dropoff`,
}
